module.exports = __webpack_public_path__ + "static/media/lightblue.220aae2e.jpg";